import {observable, action} from 'mobx'
import {isAuthenticated,authenticateSuccess,logout} from '../utils/Session'
import {getVal} from './server'

class AppStore {
  @observable isLogin = isAuthenticated() === 'true'; //利用cookie来判断用户是否登录，避免刷新页面后登录状态丢失
  @observable loginUser = getVal("loginUser",{});
  
  @action toggleLogin(flag) {
    if (flag) {
      authenticateSuccess(true)
      this.isLogin = true
    } else {
      logout()
      this.isLogin = false
    }
  }
}

export default new AppStore()


// WEBPACK FOOTER //
// ./src/store/appStore.js